import * as actionTypes from '../actions';

const initialState = {
    showRegistration: true,
    showInstream: false,
    showPlanCompare: false,
    showPlanInformation: false,
    showExplaination: false,
    showDisclaimer: false,
    showMethodology: false,
    showGlossary: false,
    showRates: false,
    showProducts: false,
    showIntroduction: false,
    showBackToIntroductionButton: false
};

let menuRegistration = () => {
    return {
        showRegistration: true,
        showInstream: false,
        showPlanCompare: false,
        showPlanInformation: false,
        showExplaination: false,
        showDisclaimer: false,
        showMethodology: false,
        showGlossary: false,
        showRates: false,
        showProducts: false,
        showIntroduction: false,
        showBackToIntroductionButton: false
    };
};

let menuPlanning = (state) => {
    return {
        showRegistration: false,
        showInstream: false,
        showPlanCompare: state.showPlanCompare,
        showPlanInformation: true,
        showExplaination: true,
        showDisclaimer: true,
        showMethodology: true,
        showGlossary: true,
        showRates: false,
        showProducts: false,
        showIntroduction: false,
        showBackToIntroductionButton: true
    };
};

let menuCompare = () => {
    return {
        showRegistration: false,
        showInstream: false,
        showPlanCompare: true,
        showPlanInformation: true,
        showExplaination: true,
        showDisclaimer: true,
        showMethodology: true,
        showGlossary: true,
        showRates: false,
        showProducts: false,
        showIntroduction: false,
        showBackToIntroductionButton: true
    };
};

let adminLoginPage = () => {
    return {
        showRegistration: false,
        showInstream: false,
        showPlanCompare: false,
        showPlanInformation: false,
        showExplaination: false,
        showDisclaimer: false,
        showMethodology: false,
        showGlossary: false,
        showRates: false,
        showProducts: false,
        showIntroduction: false,
        showBackToIntroductionButton: false
    }
}

let adminPage = () => {
    return {
        showRegistration: false,
        showInstream: false,
        showPlanCompare: false,
        showPlanInformation: false,
        showExplaination: false,
        showDisclaimer: false,
        showMethodology: false,
        showGlossary: false,
        showRates: true,
        showProducts: true,
        showIntroduction: false,
        showBackToIntroductionButton: false
    }
}

let introductionPage = () => {
    return {
        showRegistration: false,
        showInstream: false,
        showPlanCompare: false,
        showPlanInformation: false,
        showExplaination: false,
        showDisclaimer: false,
        showMethodology: false,
        showGlossary: false,
        showRates: false,
        showProducts: false,
        showIntroduction: true,
        showBackToIntroductionButton: false
    }
}

const menuReducer = (state = initialState, action) => {

    if (action.type === actionTypes.MENU_REGISTRATION) {
        return menuRegistration();
    }

    if (action.type === actionTypes.MENU_PLANNING) {
        return menuPlanning(state);
    }

    if (action.type === actionTypes.MENU_PLANCOMPARE) {
        return menuCompare();
    }

    if (action.type === actionTypes.ADMIN_LOGIN_PAGE) {
        return adminLoginPage();
    }

    if (action.type === actionTypes.ADMIN_PAGE) {
        return adminPage();
    }

    if (action.type === actionTypes.MENU_INTRODUCTION) {
        return introductionPage();
    }

    return state;
};

export default menuReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/menu.js